<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'" (click)="showSearchResult = false"><a
        [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" (click)="isViewScreen = false;" class="text-secondary"> Account
        Management</a></small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'" (click)="showSearchResult = false"><a
        [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/account-management']" (click)="isViewScreen = false;" class="text-secondary"> Account
        Management&nbsp;</a></small>
    <small *ngIf="accountCategory== 'DEALER'" (click)="showSearchResult = false"><a [routerLink]="['/dealer']"
        class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" (click)="isViewScreen = false;" class="text-secondary"> Account
        Management</a></small>
    <small *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'" (click)="showSearchResult = false"><a [routerLink]="['/corporate']"
        class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" (click)="isViewScreen = false;" class="text-secondary"> Account
        Management</a></small>
    <small *ngIf="isViewScreen" class="text-secondary">/&nbsp;{{selectedPkgForView.name}}</small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="onNavSearchClick();">/ Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row align-items-center justify-content-center no-gutters">
  <div class="col-12">
    <app-search-results [locationList]="searchedLocationList" [servicePackageList]="searchedServicePackageList"
      [vehicleList]="searchedVehicleList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult && !isViewScreen">
  <div class="row pt-2 no-gutters">

    <div class="col-xl-7 col-lg-7 col-md-6 col-sm-7 col-12 pr-0">
      <button class="btn btn-transparent font-nissan-brand-w01-light" style="padding-left: unset;"
        [routerLink]="['/charges']">CHARGES&nbsp;<span><i class="fas fa-chevron-right"></i></span></button>
      <button class="btn btn-transparent font-nissan-brand-w01-light" [routerLink]="['/usage']">USAGE&nbsp;<span><i
            class="fas fa-chevron-right"></i></span></button>
      <!-- <button class="btn btn-transparent font-nissan-brand-w01-light" [routerLink]="['/certificates']">CERTIFICATES&nbsp;<span><i class="fas fa-chevron-right"></i></span></button> -->
      <!-- <button *ngIf="!utilService.isHideLocation" class="btn btn-transparent font-nissan-brand-w01-light"
        [routerLink]="['/locations']">LOCATIONS&nbsp;<span><i class="fas fa-chevron-right"></i></span></button> -->
      <button class="btn btn-transparent font-nissan-brand-w01-light"
        [routerLink]="['/vehicles']">VEHICLES&nbsp;<span><i class="fas fa-chevron-right"></i></span></button>
      <!-- Do not delete below comment. Hidden location option -->
      <!-- <button *ngIf="['DEALER', 'CORPORATE'].includes(accountCategory)" class="btn btn-transparent font-nissan-brand-w01-light" -->
      <!-- <button class="btn btn-transparent font-nissan-brand-w01-light pr-0" [routerLink]="['/locations']">LOCATIONS&nbsp;<span><i class="fas fa-chevron-right"></i></span></button> -->
      <!-- <button *ngIf="['DEALER', 'CORPORATE'].includes(accountCategory)" -->
      <!-- <button *ngIf="!doesAccountSupportsDongle()"
        class="btn btn-transparent font-nissan-brand-w01-light pr-0" [routerLink]="['/devices']">DEVICES&nbsp;<span><i
            class="fas fa-chevron-right"></i></span></button> -->
    </div>

    <div class="col-xl-5 col-lg-5 col-md-6 col-sm-5 col-12 text-right">
      <div class="row no-gutters">
        <div class="col-12 text-right">
          <button class="btn btn-primary border mr-1 btn-165 d-none d-sm-inline-block" data-toggle="modal"
            data-target="#importupdatePackage" data-backdrop="static" data-keyboard="false"
            (click)="importFile = null">Update Packages
            <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
          </button>
          <!-- <button *ngIf="!['DEALER', 'CORPORATE'].includes(accountCategory)" class="btn btn-primary border btn-165" -->
          <button *ngIf="authService.accountData.isShowDeveloperUser && doesAccountSupportsDongle()" class="btn btn-primary border btn-165"
            (click)="apiAccess.openDeveloperAccess()">Developer Access
            <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3 bg-light no-gutters ml-0 mr-0 py-3">
    <div class="col-6 text-center">
      <div class="font13-400">Vehicles</div>
      <div class="font14-600 mt-1">{{connectedVehicles}}</div>
    </div>
    <div class="col-6 text-center ">
      <div class="font13-400">Service Packages</div>
      <div class="font14-600 mt-1">{{pkgList.length}}</div>
    </div>
    <!-- <div class="col-4 text-center">
      <div class="font13-400">Fleet Locations</div>
      <div class="font14-600 mt-1">{{locations.length}}</div>
    </div> -->
  </div>

  <div class="row mt-3 no-gutters">
    <div class="col-12 mt-2 mb-2 heading font-nissan-brand-w01-light">Packages</div>
    <div class="col-12 table-responsive no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light">
          <tr>
            <th scope="col">Package Name</th>
            <th scope="col">Services</th>
            <th scope="col" class="text-center">Vehicles</th>
            <th scope="col">Rate-Plan Type</th>
            <th scope="col">Additional Discount</th>
          </tr>
        </thead>
        <tbody class="max-height-57">
          <tr class="cursor-pointer" *ngFor="let package of pkgList; let i = index"
            (click)="packageClickedForView(package)">
            <td>{{package.name}}</td>
            <td>
              <div *ngFor="let service of package.services">
                {{service.name}}
              </div>
            </td>
            <td class="text-center">{{package.usageCount}}</td>
            <td class="pointer" (click)="packageClickedForView(package)">
              <span>{{package.packageRatePlan.ratePlanType | customText}}</span><br>
              <span>{{package.packageRatePlan.usageType | customText}}</span>
            </td>
            <td class="pointer" (click)="packageClickedForView(package)">
              <span
                *ngIf="(package.packageRatePlan.ratePlanType=='DEFAULT_SERVICE_RATES_OVERAGE_PRICING' || package.packageRatePlan.usageType == 'OVERAGE_CHARGING') && package.packageRatePlan.baseTierDiscount">
                Base Tier : {{package.packageRatePlan.baseTierDiscount}}%</span><br>
              <span
                *ngIf="(package.packageRatePlan.ratePlanType=='DEFAULT_SERVICE_RATES_OVERAGE_PRICING' || package.packageRatePlan.usageType == 'OVERAGE_CHARGING')&& package.packageRatePlan.overAgeTierDiscount">
                Overage Tier : {{package.packageRatePlan.overAgeTierDiscount}}%</span>
              <span
                *ngIf="package.packageRatePlan.additionalDiscount">{{package.packageRatePlan.additionalDiscount}}%</span>
              <span
                *ngIf="package.packageRatePlan.ratePlanType!='PREPAID' && !package.packageRatePlan.baseTierDiscount && !package.packageRatePlan.overageTierDiscount && !package.packageRatePlan.additionalDiscount">
                None </span>
              <span *ngIf="package.packageRatePlan.ratePlanType=='PREPAID'">NA</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div *ngIf="!showSearchResult && isViewScreen">
  <app-view-account-service-package-new [servicePackageData]="selectedPkgForView" [isShowEditbtn]="false"
    (submitEmitter)="submitButtonOfViewClicked($event)" (closeEmitter)="closeOfViewClicked($event)">
  </app-view-account-service-package-new>
</div>

<!-- Modal API Access -->
<developer-access #apiAccess></developer-access>

<button type="button" class="btn btn-primary" id="openConfirmationModel" [hidden]="true" data-toggle="modal"
  data-target="#confirmationModel" data-backdrop="static" data-keyboard="false">Hidden Btn</button>


<!-- Import location modal -->
<div class="modal fade" id="importLocation" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="importLocationTitle">Import Locations</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="importLocationInput.value=null">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-2 pb-2">
        <div class="form-group mb-0">
          <label class="heading">Upload UTF-8 Encoded CSV File</label>
          <label class="mt-1" *ngIf="accountDetail">
            <span class="text-muted font13-400">Please use AccountId</span>
            {{accountDetail.id}}
            <span class="text-muted font13-400">for</span><br>
            {{accountDetail.name}}</label>
          <input #importLocationInput class="import-light-btn mt-2 mb-3" type="file" accept=".csv"
            (change)="onFileSelected($event.target.files, 'AddLocation')">

          <label>
            <span class="text-muted font13-400">Format for Import Location
              filename:</span><br>NCC_AddLocation_&lt;accountId&gt;_&lt;timestamp&gt;.csv</label><br>
          <label class=" mt-1" *ngIf="accountDetail">
            <span class="text-muted font13-400">For example :</span><br>
            NCC_AddLocation_{{accountDetail.id}}_05132019101630.csv</label><br>
          <label class="mt-1">
            <span class="text-muted font13-400">CSV file data format :</span><br>Name, Street, City, State, Zipcode,
            Latitude, Longitude</label><br>
          <ul>
            <li class="text-muted txt-small">Street, City, State and Zipcode are mandatory</li>
            <li class="text-muted txt-small">Latitude and Longitude format : decimal values with - sign for South/ West
              respectively.</li>
            <label class="mt-1 font13-400">
              <span class="text-muted">For example :</span><br>
              Latitude S 32.4999392361 could be given as -32.4999392361, <br>
              Longitude W 92.0787847222 could be given as -92.0787847222.</label>
          </ul>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="importLocationInput.value=null">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" [disabled]="importFile == null"
          (click)="uploadFile()">UPLOAD</button>
      </div>
    </div>
  </div>
</div>

<!-- Import setupLocation modal -->
<div class="modal fade" id="importsetupLocation" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="importsetupLocationTitle">Add Vehicles to Fleet Locations</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="vehicleToFleetLocationInput.value=null">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-2 pb-2">
        <div class="form-group mb-0">
          <label class="heading">Upload UTF-8 Encoded CSV File</label>
          <label class="mt-1" *ngIf="accountDetail">
            <span class="text-muted font13-400">Please use AccountId </span>
            {{accountDetail.id}}
            <span class="text-muted font13-400">for</span><br>
            {{accountDetail.name}}</label>
          <input #vehicleToFleetLocationInput class="import-light-btn mt-2 mb-3" type="file" accept=".csv"
            (change)="onFileSelected($event.target.files, 'VehicleLocationMapping')">
          <label>
            <span class="text-muted font13-400">Format for Update Locations (Vehicle-Location Mapping)
              filename:</span><br>
            NCC_VehicleLocationMapping_&lt;accountId&gt;_&lt;timestamp&gt;.csv</label><br>
          <label class="mt-1" *ngIf="accountDetail">
            <span class="text-muted font13-400">For example :</span><br>
            NCC_VehicleLocationMapping_{{accountDetail.id}}_05132019101630.csv</label><br>
          <label class="mt-1">
            <span class="text-muted font13-400">CSV file data format :</span><br>VIN, HomeLocationId,
            CurrentLocationId, isDeleted</label><br>
          <ul>
            <li class="text-muted txt-small">VIN and HomeLocationId are mandatory</li>
            <li class="text-muted txt-small">CurrentLocationId is optional and if not provided would be set to
              HomeLocationId by default.</li>
            <li class="text-muted txt-small">isDeleted : boolean. If set to true, vehicle-location (homelocationId)
              mapping will be deleted</li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="vehicleToFleetLocationInput.value=null">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" [disabled]="importFile == null"
          (click)="uploadFile()">UPLOAD</button>
      </div>
    </div>
  </div>
</div>

<!-- Import updatePackage modal -->
<div class="modal fade" id="importupdatePackage" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="importupdatePackageTitle">Map/ Assign Service Packages to Vehicles</h5>
        <button type="button" id="closeImportupdatePackage" (click)="resetUpdatePackageImport()" class="close"
          data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-2 pb-2 hide-x-scroll">
        <form>
          <!-- <div class="form-group mb-0">
            <label class="heading">Upload UTF-8 Encoded CSV File</label><br>
            <label *ngIf="accountDetail" class="mt-2"><span class="text-muted font13-400">AccountId for
                {{accountDetail.name}}
                :</span><br>{{accountDetail.id}}</label>

            <div class="row mt-2 mb-3">
              <div class="col-12">
                <div class="custom-file">
                  <input #assignPkgToVehicleInput type="file" accept=".csv" class="custom-file-input" id="packageImport"
                    (change)="onFileSelected($event.target.files, 'VehicleServicePackageMapping')">
                  <label class="custom-file-label" for="packageImport">{{importFileName.substring(0,40)}} <span
                      *ngIf="importFileName != CHOOSE_FILE">...</span></label>
                </div>
              </div>
              <div class="col-12" *ngIf="importFileName != CHOOSE_FILE"><span
                  class="font11-400">{{importFileName}}</span></div>
            </div>

            <label class="mt-1">
              <span class="text-muted font13-400">Format for Vehicle Service Package Mapping
                filename:</span><br>NCC_VehicleServicePackageMapping_&lt;accountId&gt;_&lt;timestamp&gt;.csv</label><br>
            <label class="mt-1" *ngIf="accountDetail">
              <span class="text-muted font13-400">For example :</span><br>
              NCC_VehicleServicePackageMapping_{{accountDetail.id}}_05132019101630.csv</label><br>
            <label class="mt-1">
              <span class="text-muted font13-400">CSV file data format :</span><br>
              VIN, Package ID,
              isDeleted</label><br>
            <ul>
              <li class="text-muted txt-small">VIN and Service Package ID are mandatory</li>
              <li class="text-muted txt-small">isDeleted : boolean If set to true, package mapping for vehicle will be
                deleted
              </li>
            </ul>
          </div> -->
        
          <div class="form-group mb-0">
            <label class="heading">Upload UTF-8 Encoded CSV File</label><br>
  
            <div class="row mt-2 mb-3">
              <div class="col-12">
                <div class="custom-file">
                  <input #assignPkgToVehicleInput type="file" accept=".csv" class="custom-file-input" id="packageImport"
                    (change)="onFileSelected($event.target.files, 'VehicleServicePackageMapping')">
                  <label class="custom-file-label" for="packageImport">{{importFileName.substring(0,40)}} <span
                      *ngIf="importFileName != CHOOSE_FILE">...</span></label>
                </div>
              </div>
              <div class="col-12" *ngIf="importFileName != CHOOSE_FILE"><span class="font11-400">{{importFileName}}</span>
              </div>
            </div>
  
            <label class="text-muted txt-small">
              <span>
                Download the <a class="a_format" (click)="downloadSampleCsv(csvSampleImportVehicleServicePackageMappingFileName, csvSampleImportVehicleServicePackageMappingFileUrl)">sample CSV file</a> 
                for a vehicle package mapping template.&nbsp;</span>
                <span>Ensure to  remove the example vehicle package mapping record before adding your own list and update the date-time(24-hour format) YYYYMMDDHHmm in filename while saving, for example,&nbsp;</span>
                <br><span class="font12-400">NCC_VehicleServicePackageMapping_{{yyyymmddDate}}.csv.</span>
            </label>
            <br>
  
            <label class="mt-2">
              <span class="text-muted txt-small">CSV file data format :</span>
              <br>
              <span class="font12-400">
                VIN<sup class="maroon asterisk-8">&#10033;&nbsp;</sup>, 
                PackageId<sup class="maroon asterisk-8">&#10033;&nbsp;</sup>,
                isDeleted
              </span>
            </label>
            <br>
            <ul class="mb-0">
              <li class="text-muted txt-small">Fields marked by <span class="maroon astrisk">&#10033;&nbsp;</span> are mandatory</li>
              <li class="text-muted txt-small">isDeleted : boolean. If set to true, vehicle-package mapping will be deleted</li>
            </ul>      
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="resetUpdatePackageImport()">CANCEL</button>
        <button [disabled]="importFile == null" type="button" class="btn btn-primary btn-80"
          (click)="uploadFile()">UPLOAD</button>
      </div>
    </div>
  </div>
</div>

<!-- Import removeVehicle modal -->
<div class="modal fade" id="importremoveVehicle" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="importremoveVehicleTitle">Delete/Remove Vehicles from Fleet Account</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="removeVehicleFromFleetAccountInput.value=null">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-2 pb-2">
        <div class="form-group mb-0">
          <label class="heading">Upload UTF-8 Encoded CSV File</label>
          <label class="mt-1" *ngIf="accountDetail">
            <span class="text-muted font13-400">Please use AccountId </span>{{accountDetail.id}}
            <span class="text-muted font13-400"> for </span><br>
            {{accountDetail.name}} </label>
          <input #removeVehicleFromFleetAccountInput class="import-light-btn mt-2 mb-3" type="file" accept=".csv"
            (change)="onFileSelected($event.target.files, 'RemoveVehicle')">
          <label class="mt-1">
            <span class="text-muted font13-400">Format for Remove Vehicle
              filename:</span><br>
            NCC_RemoveVehicle_&lt;accountId&gt;_&lt;timestamp&gt;.csv</label><br>
          <label class="mt-1" *ngIf="accountDetail">
            <span class="text-muted font13-400">For example :</span><br>
            NCC_RemoveVehicle_{{accountDetail.id}}_05132019101630.csv</label><br>
          <label class="mt-1">
            <span class="text-muted font13-400">CSV file data format :</span><br>
            VIN, reasonCode</label><br>
          <ul>
            <li class="text-muted txt-small">Both the fields are mandatory.</li>
            <li class="text-muted txt-small">ReasonCode could have value SOLD.</li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="removeVehicleFromFleetAccountInput.value=null">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" [disabled]="importFile == null"
          (click)="uploadFile()">UPLOAD</button>
      </div>
    </div>
  </div>
</div>

<!-- <app-account-billing-profile #billingProfile></app-account-billing-profile> -->